<!-- chat-details.component.html -->
<div class="chat-container">
  <!-- الهيدر -->
  <div class="chat-header" *ngIf="chatData">
    <div class="header-info">
      <div class="user-avatar">
        <img 
          [src]="getOtherUser().image" 
          [alt]="getOtherUser().name"
          onerror="this.src='https://via.placeholder.com/50/667eea/ffffff?text=U'"
        >
      </div>
      <div class="user-details">
        <h2 style="color: #fff !important;">{{ getOtherUser().name }}</h2>
        <!-- <div class="status online">
          <i class="fas fa-circle"></i> {{ 'CHAT.ONLINE' | translate }}
        </div> -->
      </div>
    </div>
  </div>

  <!-- حالة التحميل -->
  <div class="loading-container" *ngIf="loading">
    <div class="loading-spinner">
      <i class="fas fa-spinner fa-spin"></i>
      <span>{{ 'MENU.CHAT.LOADING' | translate }}</span>
    </div>
  </div>

  <!-- رسالة الخطأ -->
  <div class="error-container" *ngIf="error && !loading">
    <div class="error-message">
      <i class="fas fa-exclamation-triangle"></i>
      {{ error }}
    </div>
  </div>

  <!-- منطقة المحادثة -->
  <div 
    class="chat-messages" 
    #chatMessages
    *ngIf="chatData && !loading"
  >
    <!-- رسائل المحادثة -->
    <div 
      *ngFor="let message of chatData.messages" 
      [class]="isCurrentUser(message) ? 'message sent' : 'message received'"
    >
      <div class="message-header">
        <span class="sender-name">{{ message.sender.name }}</span>
        <span class="message-time">{{ formatTime(message.created_at) }}</span>
      </div>
      
      <div class="message-content">
        <!-- إذا كانت صورة -->
        <div *ngIf="isImageMessage(message)" class="image-message">
          <img 
            [src]="getImageUrl(message)" 
            [alt]="'صورة من ' + message.sender.name"
            class="message-image"
            (click)="openImage(getImageUrl(message))"
          >
          <div class="image-caption">📷 {{ 'MENU.CHAT.IMAGE' | translate }}</div>
        </div>
        
        <!-- إذا كانت نص -->
        <div *ngIf="!isImageMessage(message)" class="text-message">
          {{ getMessageContent(message) }}
        </div>
      </div>
      
      <div class="message-status">
        {{ (isCurrentUser(message) ? 'MENU.CHAT.SENT' : 'MENU.CHAT.RECEIVED') | translate }}
      </div>
    </div>
  </div>

  <!-- معلومات الجلسة -->
  <div class="session-info" *ngIf="chatData && !loading">
    <div class="session-details">
      <div class="session-item" *ngIf="chatData.messages.length > 0">
        <i class="far fa-calendar"></i>
        <span>{{ 'MENU.CHAT.FIRST_MESSAGE' | translate }}: {{ formatDate(chatData.messages[chatData.messages.length - 1].created_at) }}</span>
      </div>
      <div class="session-item">
        <i class="far fa-comments"></i>
        <span>{{ getMessagesCountText() }}</span>
      </div>
    </div>
    <div class="session-item">
      <i class="fas fa-shield-alt"></i>
      <span>{{ 'MENU.CHAT.SECURE_CHAT' | translate }}</span>
    </div>
  </div>

  <!-- منطقة الإدخال (يمكن إضافتها لاحقًا) -->
  <!-- <div class="chat-input">
    <div class="input-group">
      <textarea 
        class="message-input" 
        [placeholder]="'CHAT.TYPE_MESSAGE' | translate" 
        rows="1"
      ></textarea>
    </div>
    <button class="send-btn" [title]="'CHAT.SEND' | translate">
      <i class="fas fa-paper-plane"></i>
    </button>
  </div> -->
</div>